import MutualBigLogo from '../../images/mutual-big-logo.svg';
import Apple from '../../images/apple-logo.png'
import newMutualLogoLogin from '../../images/new-logo-update.svg'


const appleLogoStyle = {
    position: 'relative' as 'relative',
    top: '1px',
    right: '4px'
}

export const MutualLogoImage = () => {
    return (
        <img src={MutualBigLogo} alt="Mutual Big Login Logo" />
    )
}

export function LoginAppleIcon(){
    return (
        <div>
          <img style={appleLogoStyle} src={Apple} alt="Apple Logo" />
        </div>
    )
}

export function NewMutualLogoLogin(){
    return (
        <div>
          <img src={newMutualLogoLogin} alt="New Logo Login" />
        </div>
    )
}
